import React, { useState } from "react";

function PayPremium() {
  const [showPolicy, setShowPolicy] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [policyNumber, setPolicyNumber] = useState("");

  const handleInsurerChange = (e) => {
    setShowPolicy(!!e.target.value);
  };

  const handlePolicyChange = (e)=>{
    setPolicyNumber(e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
     // show the popup
    
  };
  const closeModal = () => setShowModal(false);

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10 px-8">
          <div className="card shadow p-9 rounded-4 border-0 mb-5">
            <div className="bg-blue">
            <h1 className="text-center  fw-bold display-5 custom-heading">
              Check Premium Payable
            </h1>
            </div>
        
            <form onSubmit={handleSubmit}>
              {/* Insurer Dropdown */}
              <div className="mb-4 mx-4">
                <label htmlFor="insurerSelect" className="form-label fw-semibold  ">
                  Select Insurance Company:
                </label>
                <select
                  id="insurerSelect"
                  className="form-select form-select-lg rounded-3 custom-input "
                  onChange={handleInsurerChange}
                >
                  <option value="">Select Insurance Company</option>

                  <option value="1">Acko General Insurance Health</option>
                  <option value="2">Acko General Insurance Motor</option>
                  <option value="3">Aditya Birla Sun Life Insurance</option>
                  <option value="4">Aditya Birla Health Insurance Co Limited</option>
                  <option value="5">Bandhan Life Insurance</option>
                  <option value="6">Agriculture Insurance Company of India Ltd</option>
                  <option value="7">Aviva Life Insurance</option>
                  <option value="8">Bajaj Allianz General Insurance</option>
                  <option value="9">Bajaj Allianz Life Insurance Company Limited</option>
                  <option value="10">Bajaj Finance Ltd - Corporate Agent</option>
                  <option value="11">BHARTI AXA Life Insurance</option>
                  <option value="12">Canara HSBC Life Insurance Co Ltd</option>
                  <option value="13">Care Health Insurance</option>
                  <option value="14">Cholamandalam MS General Insurance Co Ltd</option>
                  <option value="15">CreditAccess Life Insurance Limited</option>
                  <option value="16">Edelweiss Tokio Life Insurance Company Limited</option>
                  <option value="17">HDFC Life Insurance (for Former Exide Life Customers only)</option>
                  <option value="18">Future Generali India Insurance Co Ltd-General Insurance</option>
                  <option value="19">Future Generali India Life Insurance Company Limited</option>
                  <option value="20">Go Digit Life Insurance Ltd</option>
                  <option value="21">Go Digit Insurance</option>
                  <option value="22">HDFC Life Insurance</option>
                  <option value="23">HDFC Ergo General Insurance Company (Health)</option>
                  <option value="24">HDFC ERGO General Insurance (Motor)</option>
                  <option value="25">ICICI Lombard General Insurance (Motor)</option>
                  <option value="26">ICICI Prudential Life Insurance First Premium</option>
                  <option value="27">ICICI Prudential Life Insurance Renewal</option>
                  <option value="28">ICICI Lombard General Insurance (Health)</option>
                  <option value="29">Ageas Federal Life Insurance Company Limited</option>
                  <option value="30">Iffco Tokio General Insurance Company Limited</option>
                  <option value="31">IndiaFirst Life Insurance Company Ltd</option>
                  <option value="32">Kotak Life Insurance Company Limited</option>
                  <option value="33">Kotak Mahindra General Insurance Company Limited</option>
                  <option value="34">Liberty General Insurance Limited</option>
                  <option value="35">Life Insurance Corporation of India</option>
                  <option value="36">Magma HDI - Motor Insurance</option>
                  <option value="37">Magma HDI - Health Insurance</option>
                  <option value="38">Magma HDI - Non Motor Insurance</option>
                  <option value="39">ManipalCigna Health Insurance</option>
                  <option value="40">Niva Bupa Health Insurance Company Limited</option>
                  <option value="41">Max Life Insurance Company Limited</option>
                  <option value="42">Pnb Metlife India Insurance Company Ltd</option>
                  <option value="43">Pramerica Life Insurance Limited</option>
                  <option value="44">Raheja QBE General Insurance Company Limited</option>
                  <option value="45">Reliance General Insurance Company Limited (Health)</option>
                  <option value="46">Reliance General Insurance Company Limited (Motor)</option>
                  <option value="47">Reliance Nippon Life Insurance</option>
                  <option value="48">Royal Sundaram General Insurance Co. Limited</option>
                  <option value="49">SBI General Health Insurance</option>
                  <option value="50">SBI General Motor Insurance</option>
                  <option value="51">SBI Life Insurance Company Limited</option>
                  <option value="52">Shriram General Insurance</option>
                  <option value="53">Shriram Life Insurance Co. Ltd.</option>
                  <option value="54">Shriram General Insurance - Quote Payment</option>
                  <option value="55">Shriram Life Insurance - Quote Payment</option>
                  <option value="56">Star Union Dai Ichi Life Insurance</option>
                  <option value="57">Star Health And Allied Insurance Company</option>
                  <option value="58">TATA AIA Life Insurance</option>
                  <option value="59">TATA AIG General Insurance Co. Ltd Retail</option>
                  <option value="60">The Oriental Insurance Company Limited</option>
                  <option value="61">United India Insurance Company Limited</option>
                  <option value="62">United India Insurance - Agent Collection</option>
                  <option value="63">Universal Sompo General Insurance Co Limited Motor</option>
                  <option value="64">Zuno General Insurance</option>
               
                </select>
                <p className="text-end m-2">Please log in to check your premium status.</p>

              </div>

              {/* Policy Number Input */}
              {/* {showPolicy && (
                <div className="mb-4">
                  <label htmlFor="policyNumber" className="mx-4 form-label fw-semibold ">
                    Enter Policy Number:
                  </label>
                  <input
                    value={policyNumber}
                    type="text"
                    id="policyNumber"
                    className="mx-4 form-control form-control-lg rounded-3 custom-input"
                    placeholder="Enter your policy number"
                    onChange={handlePolicyChange}
                  />
                </div>
              )} */}

              {/* Submit Button */}
              <div className="text-center">
                <button className="btn btn-primary btn-lg px-5 mb-3" disabled={!showPolicy} onClick={()=>window.location.href = "https://auth.finrelinsure.com/login"}>
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="bg-gradient-blue modal-header">
                <h5 className="modal-title">Premium Status</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <p>Please log in to check your premium status.</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  cancel
                </button>
                <button className="btn btn-primary " onClick={()=>window.location.href = "https://www.google.com/"}>Proceed</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}


      {/* Custom Styles */}
      <style jsx>{`
        .custom-heading {
          font-family: "Poppins", "Arial", sans-serif; /* Bold & interesting font */
          color: #0d6efd;
        }
        .custom-input:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
          outline: none;
        }
      `}</style>
    </div>
  );
}

export default PayPremium;
